// extracted by mini-css-extract-plugin
export default {"tableCell":"external-disruption_tableCell__hdHZK","tableCellWrap":"external-disruption_tableCellWrap__kPSEO","riskType":"external-disruption_riskType__26fTA"};